// extracted by mini-css-extract-plugin
export var container = "_d1-0";
export var infoIcon = "_d1-2";
export var internalLabel = "_d1-3";
export var titleRowCol = "_d1-1";